import React from 'react';
import { OnboardingContainer } from '../../../components';
import {
  StyledButton,
  Content,
  ContentContainer,
  NoteText,
  TextContainer,
  Title,
  Subtitle,
} from './IdVerificationPage.styles';
import { ReactComponent as FaceIdIcon } from '../../../assets/icons/face-id.svg';
import { useDispatch, useSelector } from 'react-redux';
import { notifyError } from '../../../utils/notify';
import { selectUser, setUserStatus } from '../../../store/slices/user/slice';
import { selectInfluencerRequestActionsPending } from '../../../store/slices/influencerRequest/slice';
import { getOrCreateIdVerificationToken } from '../../../store/slices/influencerRequest/asyncThunks';
import { INFLUENCER_REQUEST_STATUS } from '../../../utils/constants';

const IdVerificationPage = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const { getOrCreateIdVerificationToken: getOrCreateIdVerificationTokenPending } = useSelector(
    selectInfluencerRequestActionsPending,
  );

  const onVerificationStartClick = () => {
    dispatch(getOrCreateIdVerificationToken())
      .unwrap()
      .then(({ sessionUrl, userStatus }) => {
        if (userStatus === INFLUENCER_REQUEST_STATUS.ID_DOCUMENT_VERIFIED) {
          dispatch(setUserStatus(INFLUENCER_REQUEST_STATUS.ID_DOCUMENT_VERIFIED));
        } else {
          // window.open(sessionUrl, '_blank').focus();
          const win = window.open(sessionUrl, '_blank', 'noopener,noreferrer');
          if (win && win.focus) {
            win.focus();
          } else {
            // fallback – open in the same tab
            window.location.href = sessionUrl;
          }
        }
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  return (
    <OnboardingContainer>
      <Content>
        <ContentContainer>
          <TextContainer>
            <Title>ID Verification</Title>
            {user.documentVerification.status !== 'In Review' ? (
              <Subtitle>Please verify your identity below</Subtitle>
            ) : (
              <NoteText>
                Thank you for submitting your documents. Your verification is currently in progress. This typically
                takes a few minutes, but may take longer depending on the volume of requests. Please stay tuned, and
                we'll notify you as soon as the process is complete.
              </NoteText>
            )}
          </TextContainer>
          {user.documentVerification.status !== 'In Review' && (
            <StyledButton
              isLoading={getOrCreateIdVerificationTokenPending}
              icon={<FaceIdIcon />}
              title="Start Verification"
              onClick={onVerificationStartClick}
            />
          )}
        </ContentContainer>
      </Content>
    </OnboardingContainer>
  );
};

export default IdVerificationPage;
